import * as React from 'react'
import { createContext, FC, useContext } from 'react'
import Button from '@mui/material/Button'
// eslint-disable-next-line max-len
import { CreateContextScheduleOptions } from '../../pages/Dashboard/Routes/UserDashboard/UserDashboardTasks/UserDashboardTasksMain/UserDashboardTask/ScheduleOptionsPopover'
import AppModal from './AppModal'
import { PaletteColors } from '../../types/common'
import { CreateContextEducationModuleOptions } from '../../pages/Dashboard/Routes/OrganizationSettings/OrganizationSettingEducationalContent/AdditionalActions'

interface AppContextModalProps {
	readonly children?: React.ReactNode
	readonly title?: string
	readonly openModalButtonText?: string
	readonly startIcon?: React.ReactNode
	readonly openButtonSx?: object
	readonly width?: string
	readonly ariaLabel?: string
	readonly buttonVariant?: 'contained' | 'outlined' | 'text'
	readonly buttonColor?: PaletteColors
	readonly fullWidth?: boolean
	readonly callback?: any | null
	readonly openButtonDisabled?: boolean
	readonly renderOpenButton?: (
		onOpen: React.MouseEventHandler<HTMLButtonElement>
	) => React.ReactNode
}

export interface AppContextModalContext {
	onCloseModal: (event?: any) => void
}

export const AppModalContext = createContext<AppContextModalContext>({
	onCloseModal: () => {},
})

const AppContextModal: FC<AppContextModalProps> = ({
	children,
	title,
	openModalButtonText,
	startIcon,
	openButtonSx,
	buttonColor = 'secondary',
	buttonVariant,
	width,
	ariaLabel,
	fullWidth,
	callback,
	openButtonDisabled,
	renderOpenButton,
}: AppContextModalProps) => {
	const [open, setOpen] = React.useState(false)
	const { setPopoverAnchor } = useContext(CreateContextScheduleOptions)
	const { setPopoverAnchor: educationalContentPopover } = useContext(
		CreateContextEducationModuleOptions
	)

	const handleOpen: React.MouseEventHandler<HTMLButtonElement> = e => {
		;(e.target as HTMLButtonElement).blur()

		setOpen(true)
		if (callback) {
			callback()
		}
	}

	const handleClose = (event: any): void => {
		event?.stopPropagation()

		setPopoverAnchor ? setPopoverAnchor(null) : setOpen(false)
		educationalContentPopover ? educationalContentPopover(null) : setOpen(false)
	}

	return (
		<AppModalContext.Provider value={{ onCloseModal: handleClose }}>
			<div style={{ width: fullWidth ? '100%' : 'auto' }}>
				{!renderOpenButton && (
					<Button
						variant={buttonVariant || 'contained'}
						color={buttonColor}
						size={'large'}
						disableElevation
						onClick={handleOpen}
						aria-label={ariaLabel}
						startIcon={startIcon}
						sx={openButtonSx}
						disabled={openButtonDisabled}
					>
						{openModalButtonText}
					</Button>
				)}

				{renderOpenButton && renderOpenButton(handleOpen)}

				<AppModal
					onClose={handleClose}
					open={open}
					title={title}
					width={width}
				>
					{children}
				</AppModal>
			</div>
		</AppModalContext.Provider>
	)
}

export default AppContextModal
